import { IProject } from "../interfaces/project.interface";
import data from "./../assets/projects.json";

export class ProjectService {
  static getProjects(query?: string) {
    return Promise.resolve({ data: data.projects });
  }

  static getProject(id: string): Promise<IProject> {
    return Promise.resolve(data.projects.find((a: any) => a.name === id) as any);
  }
}
